const doc = [({"da":({"js":({"merfoto":({"components":({"sheet-layouts":({"presentation":({"photo_types_mismatch":"Dine billeder er på vej"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;